import './SuperUserOrdersTable.css';

import * as React from 'react';
import { IOrderPlacedReportRow, IOrderCostReportRow } from '../../../infrastructure/interfaces';
import {TooltipCont} from "../../../infrastructure/tooltips";
import { connect, ConnectedProps } from "react-redux";
import {downloadOrderAnalyticsCSV, downloadProductAnalyticsCSV} from "../../../actions/actions";
import { getOrdersPlacedReport, getOrdersCostReport } from '../../../actions/orderActions';


export interface IDivisionCostTableState {
    selectedYearOrdersPlaced: number;
    selectedYearPricing: number;
    years: Array<number>;
}

//from redux store
interface StateProps {
  orderCostReport: IOrderCostReportRow[];
  orderPlacedReport: IOrderPlacedReportRow[];
}

const mapStateToProps = (state: any): StateProps => {
  return {
    orderPlacedReport: state.orderCostReport,
    orderCostReport: state.orderCostReport,
  };
};

//from redux store
interface DispatchProps {
  getOrdersPlacedReport(): void
  getOrdersCostReport(): void
  onDownloadOrdersCSV(year: number): void
  onDownloadPricingCSV(year: number): void
}

const mapDispatchToProps = (dispatch: any): DispatchProps => {
  return {
        getOrdersPlacedReport: () => {
          dispatch(getOrdersPlacedReport());
        },
        getOrdersCostReport: () => {
          dispatch(getOrdersCostReport());
        },
        onDownloadOrdersCSV(year) {
          dispatch(downloadOrderAnalyticsCSV(year));
        },
        onDownloadPricingCSV: (year: number): void => {
          dispatch(downloadProductAnalyticsCSV(year));
        }
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;
type IDivisionCostTableProps = PropsFromRedux;

class DivisionCostTable extends React.Component<IDivisionCostTableProps, IDivisionCostTableState> {
  documentElem: HTMLElement;
  constructor(props: IDivisionCostTableProps) {
    super(props);
    this.state = {
        selectedYearOrdersPlaced: new Date().getFullYear(),
        selectedYearPricing: new Date().getFullYear(),
        years: new Array<number>()
    };

      this.handleSelectionPricing = this.handleSelectionPricing.bind(this);
      this.handleSelectionOrdersPlaced = this.handleSelectionOrdersPlaced.bind(this);
  }

    componentDidMount() {
        this.setState({
            years: this.createYears()
        });
    }

  createYears() {
      let yearList: number[] = [];
      let startDate = new Date("01/01/2018").getFullYear();
      let currentDate = new Date().getFullYear();

      for (let i = startDate; i <= currentDate; i++) {
          console.log(i);
          yearList.push(i);
      }

      return yearList;
  }

  handleSelectionOrdersPlaced(event: any) {
      this.setState({selectedYearOrdersPlaced: event.target.value})
  }

  handleSelectionPricing(event: any) {
    this.setState({selectedYearPricing: event.target.value})
  }

  onDownloadOrdersCSV(year: number) {
    this.props.onDownloadOrdersCSV(year);
  }

  onDownloadPricingCSV(year: number) {
      this.props.onDownloadPricingCSV(year);
  }

  render() {
  const { years } = this.state;
  let yearsList = years.length > 0 && years.map((year, i) => {
      return (
          <option key={i}>{year}</option>
      )
  }, this);

  return(
      <React.Fragment>
        <div className="admin-table-container-vertical">
          <div className="manage-items-row-vertical">
            <div className="in-row-button-container-column">
                <select
                    value={this.state.selectedYearOrdersPlaced}
                    onChange={this.handleSelectionOrdersPlaced}>
                    {yearsList}
                </select>
                <button
                    className="btn primary-green"
                    onClick={() => this.onDownloadOrdersCSV(this.state.selectedYearOrdersPlaced)}
                    title={TooltipCont.DOWNLOAD_CSV_REPORT}
                >
                  Order Analytics
                </button>
            </div>
            <div className="in-row-button-container-column">
                <select
                    value={this.state.selectedYearPricing}
                    onChange={this.handleSelectionPricing}>
                    {yearsList}
                </select>
                <button
                    className="btn primary-green"
                    onClick={() => this.onDownloadPricingCSV(this.state.selectedYearPricing)}
                    title={TooltipCont.DOWNLOAD_CSV_REPORT}
                >
                  Product Analytics
                </button>
            </div>
          </div>
      </div>
      </React.Fragment>
    );
  }
}
export default connector(DivisionCostTable);



// WEBPACK FOOTER //
// ./src/components/SuperUser/components/DivisionCostTable.tsx